export default "__VITE_ASSET__C7si4g8p__"